import React from 'react'
import Checkbox from '@cloudscape-design/components-themed/checkbox'

// https://cloudscape.design/components/checkbox
export function RadCheckbox ({ ...rest }) {
  return (
    <Checkbox {...rest} />
  )
}
